import axios from "axios";
import { BASE_URL } from "./settings";

const URLS = {
    FILTRAR: BASE_URL + "EvolucaoGenetica/filtrar",
    CONSULTAR_GRAFICO: BASE_URL + "EvolucaoGenetica/consultarGraficoEvolucaoGenetica"
};

// Converte o retorno do endpoint novo (consultarGraficoEvolucaoGenetica, que usa
// animal_sisne/Dados_dep/resumo_pmgrn) para o formato que o restante do front-end
// (VisualizacaoGrafico.js / GraficoService.js / Tabela.js) ja espera.
//
// IMPORTANTE — alinhamento por ano:
// As tres series voltam do backend com JANELAS DE ANOS DIFERENTES (Fazenda usa
// year(now())-11 ate -2; Programa e Fazenda G2 usam ANO > 2010). E tanto
// GraficoService.getSeries quanto Tabela.js casam as series pela POSICAO no array,
// nao pelo ano. Repassar os arrays crus faz a safra 2015 da Fazenda ser comparada
// com o valor de 2011 do Programa. Por isso montamos aqui um eixo unico (a uniao
// dos anos das tres series, em ordem crescente) e preenchemos cada serie por ano,
// com null onde aquela serie nao tem valor -- o grafico desenha buraco e a tabela
// mostra celula vazia, que e a verdade.
const adaptarRespostaGrafico = (data) => {
    const grafico = (data && data.graficoEvolucaoGenetica) || [];

    const paraNumero = (v) => {
        if (v === undefined || v === null || v === "") return null;
        const n = Number(v);
        return Number.isNaN(n) ? null : n;
    };

    const indexarPorAno = (lista, campoAno, campoMedia, campoN) => {
        const mapa = new Map();
        (lista || []).forEach((x) => {
            const ano = paraNumero(x[campoAno]);
            if (ano !== null) {
                mapa.set(ano, {
                    media: paraNumero(x[campoMedia]),
                    n: paraNumero(x[campoN]),
                });
            }
        });
        return mapa;
    };

    return grafico.map((item) => {
        const rebanho = (item.evolucaoRebanho && item.evolucaoRebanho[0]) || {};

        const fazenda = indexarPorAno(rebanho.fazenda, "fazendaANO", "fazendaMedia", "fazendaN");
        const programa = indexarPorAno(rebanho.programa, "programaANO", "programaMedia", "programaN");
        const fazendaG2 = indexarPorAno(rebanho.fazendaG2, "fazendaG2ANO", "fazendaG2Media", "fazendaG2N");

        const safras = Array.from(
            new Set([].concat(
                Array.from(fazenda.keys()),
                Array.from(programa.keys()),
                Array.from(fazendaG2.keys())
            ))
        ).sort((a, b) => a - b);

        const serie = (mapa) =>
            safras.map((safra) => {
                const ponto = mapa.get(safra);
                return {
                    safra: safra,
                    media: ponto ? ponto.media : null,
                    n: ponto ? ponto.n : null,
                };
            });

        return {
            caracteristica: item.descricaoCaracteristica,
            filter: "",
            agrupamentos: [
                { legenda: "Fazenda", data: serie(fazenda) },
                { legenda: "Programa", data: serie(programa) },
                { legenda: "Fazenda G2", data: serie(fazendaG2) },
            ],
        };
    });
};

// Monta o payload no formato esperado pelo GraficoEvolucaoGeneticaRequisicaoModel
// (IdFazenda/IdRaca como numero, Caracteristicas como array de numeros) a partir
// do objeto "consulta" que o formulario acumula (onde tudo chega como string,
// por causa do send() em index.tsx que faz obj[key].toString() em cada campo).
const montarPayload = (value) => {
    const toInt = (v) => {
        if (v === undefined || v === null || v === "") return null;
        const n = parseInt(v, 10);
        return Number.isNaN(n) ? null : n;
    };

    const caracteristicasRaw = value.caracteristicas || value.Caracteristicas;
    const caracteristicas = caracteristicasRaw
        ? caracteristicasRaw
              .toString()
              .split(",")
              .map((c) => c.trim())
              .filter((c) => c.length > 0)
              .map((c) => parseInt(c, 10))
              .filter((c) => !Number.isNaN(c))
        : [];

    return {
        IdFazenda: toInt(value.Fazenda || value.fazenda),
        IdRaca: toInt(value.Raca || value.raca),
        Caracteristicas: caracteristicas,
        Categoria: value.categoria || value.Categoria || "",
        Variedade: value.variedade || value.Variedade || "",
        Sexo: value.sexo || value.Sexo || "",
        PaisOrigem: value.pais || value.Pais || value.PaisOrigem || "",
    };
};

export default class EvolucaoGeneticaService {

    static filtrar = async (value) => {
        let url = URLS.CONSULTAR_GRAFICO;
        const payload = montarPayload(value);

        try {
          const { data } = await axios.post(url, payload);
          return adaptarRespostaGrafico(data);
        } catch (err) {
          throw err.response.data;
        } finally {
          // this.setState({ loading: false });
        }
      };

}
